/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../../services/vehicle/vehicle_interfaces.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    import Languages = DealerwareWebComponents.Languages;

    export class VehicleRentalHistoryDirectiveController {
        public static $inject: string[] = [
            '$rootScope',
            '$timeout',
            '$scope',
            '$state',
            '$filter',
            'DataUtils',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'ConvertUnits',
            '$dealerwareInternationalizationDateFormats',
            '$dealerwareInternationalizationData'
        ];

        public vehicle: any;
        public locationSettings: any;
        public columns: any;
        public loader: any;
        private isMetric: boolean;
        public labels: {};

        constructor(
                public $rootScope: any,
                public $timeout: any,
                public $scope: any,
                public $state: any,
                public $filter: any,
                public DataUtils: any,
                public $mobilityCompanyAuthentication: any,
                public $dealerwareLoading: any,
                public $dealerwareNotification: any,
                public ConvertUnits: any,
                public $dealerwareInternationalizationDateFormats: any,
                public $dealerwareInternationalizationData: any) {
            this.getLabels('vehicles');
            this.isMetric = $mobilityCompanyAuthentication.location.settings.metric;
            this.initColumns();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    this.$dealerwareNotification.apiError(error);
                }
            );
        }

        public pageTransitionError(response : any) : void {
            this.loader.close();
            this.$dealerwareNotification.apiError(response);
        }

        public initColumns() : void {
            var _self = this,
                dataUtils = this.DataUtils.getInstance(),
                time_zone = this.$mobilityCompanyAuthentication.location.time_zone_name;

            this.columns = [{
                key: 'id',
                hidden: true
            },{
                key: 'reservation_confirmation',
                header: 'Contract ID',
                onClick: function(e: any, vehicleContract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.contracts.details',
                        { contractId: vehicleContract.data.reservation_id }
                    ));
                }
            },{
                key: 'customer_name',
                header: 'Customer',
                onClick: function(e: any, vehicleContract: any) {
                    $(e.target).attr('href', _self.$state.href(
                        'root.private.application.customers.details',
                        { customerId: vehicleContract.data.customer_id }
                    ));
                }
            },{
                key: 'current_state',
                header: 'Status',
                dataFilter: (v: string) => _self.getStateLabelDict(v)
            },{
                key: 'started_at',
                header: 'Started At',
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(dataUtils.formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'finished_at',
                header: 'Finished At',
                dataFilter: (ts: string) => {
                    return ts ? this.$filter('filterInternationalizationDate')(dataUtils.formatTimestampSimple(ts, time_zone)) : '';
                }
            },{
                key: 'starting_mileage_in_km',
                header: 'Starting Mileage',
                dataFilter: v => _self.convertMileage(v),
            },{
                key: 'ending_mileage_in_km',
                header: 'Ending Mileage',
                dataFilter: v => _self.convertMileage(v),
            },{
                key: 'starting_fuel_in_liters',
                header: 'Starting Fuel',
                dataFilter: v => _self.convertFuel(v),
            },{
                key: 'ending_fuel_in_liters',
                header: 'Ending Fuel',
                dataFilter: v => _self.convertFuel(v),
            },{
                key: 'total_charges',
                dataFilter: function(r: any) {
                    const value = parseFloat(r).toFixed(2);
                    if(localStorage.getItem('language') === Languages.French) {
                        return `${value} $`;
                    }
                    return _self.$filter('customCurrency')(value);
                },
                header: 'Total Charges'
            }];
        }

        private convertMileage(km): string {
            const value = parseFloat(km);
            if (isNaN(value) || value === 0) {
                return '';
            }
            const convertedValue = this.isMetric
              ? value
              : this.ConvertUnits.kmToMiles(value);
            return convertedValue.toFixed();
        }

        private convertFuel(liters) {
            const value = parseFloat(liters);
            if (isNaN(value) || value === 0) {
                return '';
            }

            const currentFuel = this.ConvertUnits.litersToGallons(value)
            const fuelCapacity = this.vehicle.vehicleDetails.data.fuel_capacity;

            return this.$rootScope.calculateFuelLevel(currentFuel, fuelCapacity);
        }

        private getStateLabelDict(state: string) {
            return (this.labels && this.labels.navItems) ? this.labels.navItems.vehicles[state] : state;
        }
    }

    getDealerwareWebComponentsModule().controller('VehicleRentalHistoryDirectiveController', VehicleRentalHistoryDirectiveController);

    export class VehicleRentalHistoryDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'VehicleRentalHistoryDirectiveController';
        public controllerAs     : string    =   'vehicleRentalHistoryController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            vehicle: '=',
            locationSettings: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/vehicle/rental_history/vehicle_rental_history_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareVehicleRentalHistory",() => new VehicleRentalHistoryDirective());
 }
